import { useState } from 'react';
import { faqList } from '@/mocks/homeData';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
                常见问题
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
                关于收录与对比的说明
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                这些问题被问得最多。如果你关心的点不在这里，可以在页面底部把线索和疑问一起发给我们。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <article
                    key={item.q}
                    className={`bg-background-50 border rounded-lg overflow-hidden transition-colors ${
                      isOpen ? 'border-primary-300' : 'border-background-200'
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:px-6 md:py-5 cursor-pointer"
                      >
                        <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6 md:pb-6">
                        <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}